export interface FixedAssetFormValueChange {
    openingValue: number;
    additions?: number | null;
    disposals?: number | null;
    transfers?: number | null;
    closingValue?: number;
    otherValue: number;
    isValid: boolean;
}
